import Relay from 'react-relay';

export default {
    user: (Component, variables) => Relay.QL`
      query {
        admin {
          ${Component.getFragment('user', variables)}
        }
      }
    `,
};

